module.exports = __webpack_public_path__ + "static/media/icon-event__nuevos-populismos-el-auge-de-la-ultraderecha.dda5cd6f.svg";